// extracted by mini-css-extract-plugin
var _1 = "container___TYsW";
var _2 = "heading__udH8R";
var _3 = "layout__AdjNG";
export { _1 as "container", _2 as "heading", _3 as "layout" }
